export default "__VITE_ASSET__DE5g3MnH__"